import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import fa from './locales/fa.json'
import moment from 'jalali-moment'

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: localStorage.getItem('language') || 'en', // Default locale
  fallbackLocale: 'en',
  messages: {
    en,
    fa
  },
  numberFormats: {
    en: {
      currency: {
        style: 'currency',
        currency: 'USD'
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      percent: {
        style: 'percent',
        useGrouping: false
      }
    },
    fa: {
      currency: {
        style: 'currency',
        currency: 'IRR',
      },
      decimal: {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      percent: {
        style: 'percent',
        useGrouping: false
      }
    }
  },
  datetimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
    },
    fa: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }
    }
  }
})

// Helper function to format dates for Persian
export const formatPersianDate = (date, format = 'YYYY/MM/DD') => {
  return moment(date).locale('fa').format(format)
}

// Set document direction based on locale
export const setDocumentDirection = (locale) => {
  document.documentElement.setAttribute('dir', locale === 'fa' ? 'rtl' : 'ltr')
  document.documentElement.setAttribute('lang', locale)
}

// Set locale and direction
export const setLocale = (locale) => {
  // Change the locale
  i18n.global.locale.value = locale
  
  // Store the locale preference
  localStorage.setItem('language', locale)
  
  // Set the document direction
  setDocumentDirection(locale)
  
  // Force update for components that don't automatically react to locale changes
  document.dispatchEvent(new CustomEvent('language-changed', { detail: locale }))
}

// Initialize direction based on stored locale
setDocumentDirection(i18n.global.locale.value)

export default i18n 